import { useState, useCallback, useLayoutEffect } from "react";
import { useParams } from "react-router-dom";
import { useContractKit } from "@celo-tools/use-contractkit";
import { get } from "axios";
import { Box, Image, VStack, Text, Button, Input } from "@chakra-ui/react";
import { ownerOfTokenId, tokenURI } from "../lib/NFT";
import Layout from "../components/layout";
import { listToken } from "../lib/Market";

const BASE_GATEWAY_URI = "https://ipfs.io/ipfs/";

async function getMetadata(uri) {
  const resp = await get(`${BASE_GATEWAY_URI}${uri.replace("ipfs://", "")}`);
  return resp.data;
}

function NFT() {
  const [token, setToken] = useState(null);
  const [price, setPrice] = useState("");

  const { kit, address, performActions } = useContractKit();
  const params = useParams();

  const loadToken = useCallback(
    async (tokenId) => {
      const uri = await tokenURI(tokenId, kit);
      if (!uri) {
        console.log(uri);
        return;
      }
      const metadata = await getMetadata(uri);
      const owner = await ownerOfTokenId(tokenId, kit);

      setToken({ ...metadata, tokenId, owner });
    },
    [kit, kit.web3]
  );

  useLayoutEffect(() => {
    if (!kit.web3 || !params.tokenId) return;

    loadToken(parseInt(params.tokenId));
  }, [params.tokenId, kit.web3]);

  return (
    <Layout>
    <VStack justifyContent='center' maxWidth='2xl'>
      {token && (
        <VStack spacing={10}>
          <Box>
            <Image
              src={`${BASE_GATEWAY_URI}${token.image.replace("ipfs://", "")}`}
              borderRadius="md"
              overflow="hidden"
            />
            <Box mt={4}>
              <Text fontSize="xl" fontWeight="bold">
                {token.title}
              </Text>

              <Text fontSize="md" mt={0.6} textColor='whiteAlpha.700'>
                {token.description}
              </Text>

              <Text mt={4} fontSize={"sm"}>
                {token.creator}
              </Text>
            </Box>
          </Box>

          {token.owner == address && (
            <Box w="full" mt={10}>
              <Text>List your NFT for sale</Text>
              <Box w="full" mt={2} display="flex">
                <Input
                  placeholder="Price to sell at"
                  onChange={(e) => setPrice(e.target.value)}
                  borderColor="gray.400"
                />
                <Button
                  ml={4}
                  colorScheme="blue"
                  onClick={() =>
                    listToken(
                      performActions,
                      parseInt(params.tokenId),
                      price,
                      address
                    ).then(console.log)
                  }
                >
                  SELL
                </Button>
              </Box>
            </Box>
          )}
        </VStack>
      )}
      </VStack>
    </Layout>
  );
}

export default NFT;
